/** Display labels for persona `type` values stored as snake_case in the API. */
export const PERSONA_TYPE_LABELS: Record<string, string> = {
  champion: 'Champion',
  blocker: 'Blocker',
  skeptic: 'Skeptic',
  economic_buyer: 'Economic Buyer',
  technical_evaluator: 'Technical Evaluator',
  end_user: 'End User',
};

/** Human-readable persona role type for UI (never show raw snake_case when avoidable). */
export function personaTypeLabel(type: string): string {
  const key = type.trim().toLowerCase();
  const known = PERSONA_TYPE_LABELS[key];
  if (known) return known;
  return type
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
